import { TranslateService } from '@ngx-translate/core';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toScannerSingleMaintenanceCheckBadge' })
export class ScannerSingleMaintenanceCheckBadgePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(isOk?: boolean | null): string {
    if (isOk === undefined || isOk === null) {
      return '-';
    }

    const badgeClass = isOk ? 'active' : 'inactive';
    const text = this.translate.instant(
      isOk ? 'scanner.maintenance.ok' : 'scanner.maintenance.warning',
    );

    return `<div class="badge rounded-pill text-bg-light"><div class="dot ${badgeClass}"></div>${text}</div>`;
  }
}
